<template>
    <v-container>
      <v-row>
        <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 12 : 6]">
          <v-img src="https://i.imgur.com/lybl1Bd.jpg" max-height="80vh" contain></v-img>
        </v-col>
        <v-col :cols="[this.$vuetify.breakpoint.smAndDown ? 12 : 6]">
          <div class="text-h2 mb-5">Changelog</div>
          <v-container
          id="scroll-target"
          style="max-height: 50vh"
          class="overflow-y-auto mt-3"
          >
          <v-expansion-panels accordion focusable>
              <v-expansion-panel
                v-for="(change, i) in changes"
                :key="i"
              >
                <v-expansion-panel-header>{{change.title}}</v-expansion-panel-header>
                <v-expansion-panel-content>
                  {{change.desc}}
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
      export default {
        name: 'changeLog',
        data: () => ({
          changes:[
            {
              title: "V 0.1",
              desc: "Beta version! Basic roulettes and basic functionality has been added."
            },
            {
              title: "V 0.2",
              desc: "Still in beta! Mobile friendly layouts have been added."
            },
            {
              title: "V 0.3",
              desc: "Beta wrapping up soon! Mobile friendly layouts have been tweaked, added bracket games."
            },
            {
              title: "V 0.4",
              desc: "Beta wrapping up soon! Mobile friendly layouts have been tweaked, added fap cards, sissy bingo."
            },
          ]
        }),
        methods: {

        },
      }
  </script>